import { Link } from './link.model';

export class ContextMenu {
  name: string;
  links: Link[];

  constructor(name: string, links: Link[]) {
    this.name = name;
    this.links = links;
  }
}



// WEBPACK FOOTER //
// ./src/app/models/context-menu.model.ts